/** All 64 general electorate constituencies, sorted alphabetically by area_id. */
export const CONSTITUENCIES = [
  { area_name: "Auckland Central",       area_id: 1  },
  { area_name: "Banks Peninsula",        area_id: 2  },
  { area_name: "Botany",                 area_id: 3  },
  { area_name: "Christchurch Central",   area_id: 4  },
  { area_name: "Christchurch East",      area_id: 5  },
  { area_name: "Coromandel",             area_id: 6  },
  { area_name: "Dunedin",                area_id: 7  },
  { area_name: "East Cape",              area_id: 8  },
  { area_name: "East Coast Bays",        area_id: 9  },
  { area_name: "Epsom",                  area_id: 10 },
  { area_name: "Glendene",               area_id: 11 },
  { area_name: "Hamilton East",          area_id: 12 },
  { area_name: "Hamilton West",          area_id: 13 },
  { area_name: "Henderson",              area_id: 14 },
  { area_name: "Hutt South",             area_id: 15 },
  { area_name: "Ilam",                   area_id: 16 },
  { area_name: "Invercargill",           area_id: 17 },
  { area_name: "Kaikōura",               area_id: 18 },
  { area_name: "Kaipara ki Mahurangi",   area_id: 19 },
  { area_name: "Kapiti",                 area_id: 20 },
  { area_name: "Kenepuru",               area_id: 21 },
  { area_name: "Māngere",                area_id: 22 },
  { area_name: "Manurewa",               area_id: 23 },
  { area_name: "Maungakiekie",           area_id: 24 },
  { area_name: "Mt Albert",              area_id: 25 },
  { area_name: "Mt Maunganui",           area_id: 26 },
  { area_name: "Mt Roskill",             area_id: 27 },
  { area_name: "Napier",                 area_id: 28 },
  { area_name: "Nelson",                 area_id: 29 },
  { area_name: "New Plymouth",           area_id: 30 },
  { area_name: "North Shore",            area_id: 31 },
  { area_name: "Northcote",              area_id: 32 },
  { area_name: "Northland",              area_id: 33 },
  { area_name: "Ōtāhuhu",               area_id: 34 },
  { area_name: "Pakuranga",              area_id: 35 },
  { area_name: "Palmerston North",       area_id: 36 },
  { area_name: "Papakura",               area_id: 37 },
  { area_name: "Port Waikato",           area_id: 38 },
  { area_name: "Rangitata",              area_id: 39 },
  { area_name: "Rangitīkei",             area_id: 40 },
  { area_name: "Remutaka",               area_id: 41 },
  { area_name: "Rotorua",                area_id: 42 },
  { area_name: "Selwyn",                 area_id: 43 },
  { area_name: "Southland",              area_id: 44 },
  { area_name: "Taieri",                 area_id: 45 },
  { area_name: "Takanini",               area_id: 46 },
  { area_name: "Tāmaki",                 area_id: 47 },
  { area_name: "Taranaki-King Country",  area_id: 48 },
  { area_name: "Taupō",                  area_id: 49 },
  { area_name: "Tauranga",               area_id: 50 },
  { area_name: "Tukituki",               area_id: 51 },
  { area_name: "Upper Harbour",          area_id: 52 },
  { area_name: "Waikato",                area_id: 53 },
  { area_name: "Waimakariri",            area_id: 54 },
  { area_name: "Wairarapa",              area_id: 55 },
  { area_name: "Waitākere",              area_id: 56 },
  { area_name: "Waitaki",                area_id: 57 },
  { area_name: "Wellington Bays",        area_id: 58 },
  { area_name: "Wellington North",       area_id: 59 },
  { area_name: "West Coast-Tasman",      area_id: 60 },
  { area_name: "Whanganui",              area_id: 61 },
  { area_name: "Whangaparāoa",           area_id: 62 },
  { area_name: "Whangārei",              area_id: 63 },
  { area_name: "Wigram",                 area_id: 64 },
];

/** Same list with an "All" option prepended — for filter dropdowns. */
export const CONSTITUENCY_OPTIONS = [
  { area_name: "All", area_id: null },
  ...CONSTITUENCIES,
];
